import type { Resource } from '../../';
export const product_sizeChart_ages_bigKids: Resource = {"default":"8 - 12 Years"};
